import {
  UPDATE_EVENTS_REQUEST,
  FETCH_RESOURCES_REQUEST,
  FETCH_RESOURCES_SUCCESS,
  FETCH_RESOURCES_FAILURE,
  UPDATE_RELOAD,
} from '../actions/scheduleAction';

const updateEvents = (existingEvents, newEvents, selector) => {
  if (!existingEvents) {
    return newEvents;
  }
  // De-dupe newEvents and existingEvents by forming an object,
  // so that the "selector" key is guaranteed to be unique in the result.
  const eventObject = {};
  existingEvents.forEach((e) => {
    eventObject[e[selector]] = e;
  });
  newEvents.forEach((e) => {
    eventObject[e[selector]] = e;
  });
  return Object.values(eventObject);
};

const initialState = {
  loading: false,
  error: null,
  events: null,
  resources: [],
  reload: false,
};

const scheduleReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case UPDATE_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RESOURCES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RESOURCES_SUCCESS:
      return {
        ...state,
        loading: false,
        resources: [...state.resources, ...action.resources],
      };
    case FETCH_RESOURCES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case UPDATE_RELOAD:
      return {
        ...state,
        reload: action.reload,
      };
    default:
      return state;
  }
};

export default scheduleReducer;
